import type { DomainStore } from '@vista-digital/occ-domain'
import { createDomainStore, DomainStoreType } from '@vista-digital/occ-domain'
import { createFetchedData, LoadingState } from '@vista-digital/utilities'
import type { Stores } from './domain-config'

export const domainStores: Stores = {
    configuration: createDomainStore({
        type: DomainStoreType.BrowserLocal,
        defaultState: { configuration: createFetchedData(LoadingState.NotLoaded) },
        name: 'lumos-configuration-domain-store',
    }),
    languageText: createDomainStore({
        type: DomainStoreType.BrowserLocal,
        defaultState: { languageText: createFetchedData(LoadingState.NotLoaded) },
        name: 'lumos-language-text-domain-store',
    }),
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any -- copied from lumos
const domainStoresArray: Array<DomainStore<any>> = Object.values(domainStores)

export const resetWebDomainStores = () => domainStoresArray.forEach(store => store.reset())
